/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

export const buttonPalette = {
    primary: {
        light: {
            main: "#1976d2",
            light: "#3287db",
            dark: "#0f4a85",
            contrastText: "white",
        },

        dark: {
            main: "#0f4a85",
            light: "#1976d2",
            dark: "#092f54",
            contrastText: "white",
        },
    },

    success: {
        light: {
            main: "#2e7d32",
            light: "#3ba340",
            dark: "#1c4f1f",
            contrastText: "white",
        },
        dark: {
            main: "#1c4f1f",
            light: "#2e7d32",
            dark: "#112e12",
            contrastText: "white",
        },
    },

    error: {
        light: {
            main: "#b71c1c",
            light: "#c62828",
            dark: "#991717",
            contrastText: "white",
        },
        dark: {
            main: "#991717",
            light: "#b71c1c",
            dark: "#6b0f0f",
            contrastText: "white",
        },
    },

    default: {
        light: {
            main: "#767676",
            light: "#8a8a8a",
            dark: "#4d4c4c",
            contrastText: "white",
        },
        dark: {
            main: "#616060",
            light: "#8a8a8a",
            dark: "#4d4c4c",
            contrastText: "white",
        },
    },
};
